import "./business.css";
import React, { useState, useEffect, useCallback } from "react";
import Card from "react-bootstrap/Card";
import Table from "react-bootstrap/Table";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Carousel from "react-bootstrap/Carousel";
import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";

import { styled } from "@mui/material/styles";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import Box from "@mui/material/Box";
import { Link } from "@mui/material";

import SwipeableViews from 'react-swipeable-views';

import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";

import {
  AiFillFacebook,
  AiOutlineTwitter,
  AiOutlineClockCircle,
} from "react-icons/ai";
import { GrNext, GrPrevious } from "react-icons/gr";
import { MdOutlineKeyboardBackspace } from "react-icons/md";

const YellowTabs = styled(Tabs)({
  "& .MuiTabs-indicator": {
    backgroundColor: "#000000",
  },
  "& .MuiTabs-indicatorSpan": {
    maxWidth: 40,
    width: "100%",
  },
});

const YellowTab = styled(Tab)({
  textTransform: "none",
  "&.Mui-selected": {
    color: "#000000",
  },
});

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}
function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && <Box>{children}</Box>}
    </div>
  );
}

//   const center = {
//     lat: 0,
//     lng: -180
//   }

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }
  componentDidCatch(error, info) {
    this.setState({ hasError: true });
  }
  render() {
    if (this.state.hasError) {
      return <h1>Something went wrong</h1>;
    }
    return this.props.children;
  }
}

function Business({ oneBusinessData, oneBusinessReviews, handleBackClick }) {
  const [tabValue, setTabValue] = useState(0);
  const [modalShow, setModalShow] = useState(false);
  const [validated, setValidated] = useState(false);
  const [hrs, setHrs] = useState(0);
  const [mins, setMins] = useState(0);
  const [bookings, setBookings] = useState(()=>{
    const items = localStorage.getItem('bookings');
    return items !== null ? JSON.parse(items) : []
  });
  const [value, setValue] = useState(0);

  const [addressRef, setAddressRef] = useState();
  const [categoryRef, setCategoryRef] = useState();
  const [rowHeight, setRowHeight] = useState();

  useEffect(() => {
    localStorage.setItem("bookings", JSON.stringify(bookings));
  }, [bookings]);

  useEffect(()=>{
    const height = Math.max(addressRef?.clientHeight,categoryRef?.clientHeight);
    setRowHeight(height);
  },[addressRef,categoryRef]);

  const addressRefCallback = useCallback((node)=>{
    setAddressRef(node);
  },[]);
  const categoryRefCallback = useCallback((node)=>{
    setCategoryRef(node);
  },[]);

  const handleModalClose = () => setModalShow(false);
  const handleModalShow = () => setModalShow(true);

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
  };
  const handleSwipeChange = (index) => {
    setValue(index);
  };
  const handleHrChange = (event) => {
    setHrs(event.target.value);
  };
  const handleMinChange = (event) => {
    setMins(event.target.value);
  };

  const handleModalSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
    }
    else{
      let booking = {
        name: oneBusinessData["name"],
        date: e.target.elements.modalDate.value,
        time: hrs + ":" + mins,
        email: e.target.elements.modalEmail.value,
      };
      setBookings((current) => [...current, booking]);
      alert("Reservation created!");
    }
    setValidated(true);
    
  };

  const deleteBooking = (e, info) => {
    var storedBookings = JSON.parse(localStorage.getItem("bookings"));
    let i;
    for(i=0;i<storedBookings.length;i++){
      if(storedBookings[i].name === info.name){
        break;
      }
    }
    storedBookings.splice(i, 1);
    localStorage.setItem("bookings", JSON.stringify(storedBookings));
    setValue({});
    alert('Reservation cancelled!');
    if(value !== undefined){
    }
  };

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: "AIzaSyB31spTUql9dS3xjsVuXeVwnjDXJMk2ljg",
  });
  let position = {
    lat: oneBusinessData["coordinates"].latitude,
    lng: oneBusinessData["coordinates"].longitude,
  };
  const onLoad = () => {
    console.log("Map loaded");
  };

  let reviewRows;
  if (oneBusinessReviews && oneBusinessReviews.hasOwnProperty("reviews")) {
    reviewRows = oneBusinessReviews["reviews"].map((info, i) => {
      return (
        <tr key={i + 1} style={{'textAlign':'left'}}>
          <td className="reviewRows">
            <b>{info["user"].name}</b>
            <p>Rating: {info.rating}/5</p>
            <p>{info.text}</p>
            <p>
              {info.time_created.substring(0, info.time_created.indexOf(" "))}
            </p>
          </td>
        </tr>
      );
    });
  }

  const carouselImages = oneBusinessData["photos"].map((photo, i) => {
    return (
      <Carousel.Item>
        <img
          style={{ width:'80vw', height: "80vw", maxWidth:"300px", maxHeight:'300px' }}
          src={photo}
          alt={"Image " + (i + 1)}
        />
      </Carousel.Item>
    );
  });

  return (
    <div>
      {Object.keys(oneBusinessData).map((value) => (
        <p>{oneBusinessData[value].alias}</p>
      ))}
      <ErrorBoundary>
        <Card
          className="text-center mx-auto"
          style={{
            marginRight: "18vw",
            marginLeft: "18vw",
            marginBottom: "10vw",
            maxWidth: "52rem",
          }}
        >
          <MdOutlineKeyboardBackspace
            onClick={handleBackClick}
            style={{
              marginLeft: "0.5rem",
              marginTop: "1rem",
              fontSize: "1rem",
            }}
          />
          <h3 style={{ marginTop: "0.35rem" }}>{oneBusinessData["name"]}</h3>
          <Box display="flex" justifyContent="center" width="100%" style={{'backgroundColor': '#fadd69'}}>
            <YellowTabs
              value={tabValue}
              onChange={handleTabChange}
              variant="scrollable"
              scrollButtons
              allowScrollButtonsMobile
              aria-label="3 business tabs"
              className="ytabs"
            >
              <YellowTab label="Business Details" {...a11yProps(0)}></YellowTab>
              <YellowTab label="Map location" {...a11yProps(1)}></YellowTab>
              <YellowTab label="Reviews" {...a11yProps(2)}></YellowTab>
            </YellowTabs>
          </Box>
          <SwipeableViews index={tabValue} onChangeIndex={handleSwipeChange}>
            <TabPanel value={tabValue} index={0}>
              <Container>
                <br />
                <br />
                <Row className="business-row">
                  <Col sm>
                    <div className="business-row row" ref={addressRefCallback} style={{'height':rowHeight}}>
                      <h5>
                        <b>Address</b>
                      </h5>
                      <p>
                        {oneBusinessData["location"]["display_address"].join(" ")}
                      </p>
                    </div>
                    <Row className="business-row">
                      <h5>
                        <b>Phone</b>
                      </h5>
                      {oneBusinessData["display_phone"] ? (
                        <p>{oneBusinessData["display_phone"]}</p>
                      ) : (
                        <p>N/A</p>
                      )}
                    </Row>
                    <Row className="business-row">
                      <h5>
                          <b>Status</b>
                        </h5>
                        {oneBusinessData["hours"] ? (
                          <p>
                            {oneBusinessData["hours"][0].is_open_now === true ? (
                              <span style={{ color: "green" }}>Open Now</span>
                            ) : (
                              <span style={{ color: "red" }}>Closed</span>
                            )}
                          </p>
                        ) : (
                          <p>N/A</p>
                        )}
                    </Row>
                  </Col>
                  <Col sm>
                    <Row className="business-row">
                      <div className="row" ref={categoryRefCallback} style={{'height':rowHeight}}>
                        <h5>
                            <b>Category</b>
                          </h5>
                          <p>
                            {oneBusinessData["categories"].map((cat, i, { length }) => {
                              if (length - 1 === i) {
                                return <> {cat.title}</>;
                              } else {
                                return <> {cat.title} |</>;
                              }
                            })}
                          </p>
                      </div>
                    </Row>
                    
                    <Row className="business-row">
                      <h5>
                        <b>Price range</b>
                      </h5>
                      {oneBusinessData["price"] ? (
                        <p>{oneBusinessData["price"]}</p>
                      ) : (
                        <p>N/A</p>
                      )}
                    </Row>
                    <Row className="business-row">
                      <h5>
                        <b>Visit yelp for more</b>
                      </h5>
                      <Link
                        href={oneBusinessData["url"]}
                        className="business-link"
                        target="_blank"
                      >
                        Business link
                      </Link>
                    </Row>
                  </Col>
                </Row>
                
                <Row>
                  <Col>
                      {   
                          localStorage.getItem('bookings') &&
                          localStorage.getItem('bookings') !== '[]' &&
                          JSON.parse(localStorage.getItem('bookings')).filter((info)=>{
                            return (
                              info.name === oneBusinessData["name"]
                            );
                          }).map((info)=>{
                              return (
                                  <Button variant="primary" onClick={(e) => deleteBooking(e, info)}>
                                      Cancel reservation
                                  </Button>
                              );
                          })
                      }
                      {
                          (!localStorage.getItem('bookings') ||
                          localStorage.getItem('bookings') === '[]' ||
                          !localStorage.getItem('bookings').includes(oneBusinessData["name"])) &&
                          <Button variant="danger" onClick={handleModalShow}>
                              Reserve Now
                          </Button>
                      }
                    

                    <Modal
                      show={modalShow}
                      onHide={handleModalClose}
                      animation={false}
                    >
                      <Modal.Header>
                        <Modal.Title>Reservation form</Modal.Title>
                      </Modal.Header>
                      <Modal.Body>
                        <h5 className="text-center">
                          <b>{oneBusinessData["name"]}</b>
                        </h5>
                        <Form
                          noValidate
                          validated={validated}
                          onSubmit={handleModalSubmit}
                        >
                          <Form.Group controlId="modalEmail">
                            <Form.Label>Email</Form.Label>
                            <Form.Control type="email" required></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Email is required
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Form.Group controlId="modalDate">
                            <Form.Label>Date</Form.Label>
                            <Form.Control
                              type="date"
                              required
                              min={
                                new Date(new Date().valueOf() - 1000 * 3600 * 24)
                                  .toISOString()
                                  .split("T")[0]
                              }
                            ></Form.Control>
                            <Form.Control.Feedback type="invalid">
                              Date is required
                            </Form.Control.Feedback>
                          </Form.Group>
                          <Row>
                            <Col>
                              <Form.Group controlId="modalTime">
                                <Form.Label>Time</Form.Label>
                                <div
                                  style={{
                                    display: "flex",
                                    marginBottom: "1rem",
                                  }}
                                >
                                  <Form.Control
                                    as="select"
                                    required
                                    onChange={handleHrChange}
                                  >
                                    <option></option>
                                    <option value="10">10</option>
                                    <option value="11">11</option>
                                    <option value="12">12</option>
                                    <option value="13">13</option>
                                    <option value="14">14</option>
                                    <option value="15">15</option>
                                    <option value="16">16</option>
                                    <option value="17">17</option>
                                  </Form.Control>
                                  <p
                                    style={{
                                      marginBottom: "auto",
                                      marginTop: "auto",
                                    }}
                                  >
                                    &nbsp;:&nbsp;
                                  </p>
                                  <Form.Control
                                    as="select"
                                    required
                                    onChange={handleMinChange}
                                  >
                                    <option></option>
                                    <option value="00">00</option>
                                    <option value="15">15</option>
                                    <option value="30">30</option>
                                    <option value="45">45</option>
                                  </Form.Control>
                                  <AiOutlineClockCircle
                                    style={{
                                      fontSize: "4rem",
                                      height: "fit-content",
                                      marginTop: "auto",
                                      marginBottom: "auto",
                                      marginLeft: "0.3rem",
                                    }}
                                  />
                                </div>
                              </Form.Group>
                            </Col>
                            <Col></Col>
                          </Row>
                          <Row>
                            <Button
                              variant="danger"
                              style={{
                                marginBottom: "1rem",
                                marginLeft: "auto",
                                marginRight: "auto",
                                width: "auto",
                              }}
                              type="submit"
                            >
                              Submit
                            </Button>
                          </Row>
                        </Form>
                        <Modal.Footer>
                          <Button
                            variant="dark"
                            onClick={handleModalClose}
                            style={{ width: "auto" }}
                          >
                            Close
                          </Button>
                        </Modal.Footer>
                      </Modal.Body>
                    </Modal>
                  </Col>
                </Row>
                <br />
                <Row>
                  <Col>
                    Share on:{" "}
                    <Link
                      target="_blank"
                      href={
                        "https://twitter.com/intent/tweet?url=" +
                        oneBusinessData["url"] +
                        "&text=Check out " +
                        oneBusinessData["name"] +
                        " on Yelp."
                      }
                    >
                      <AiOutlineTwitter
                        style={{ color: "#5298f7", fontSize: "2rem" }}
                      ></AiOutlineTwitter>
                    </Link>{" "}
                    <Link
                      target="_blank"
                      href={
                        "https://www.facebook.com/sharer/sharer.php?u=" +
                        oneBusinessData["url"]
                      }
                    >
                      <AiFillFacebook
                        style={{ color: "#0400e6", fontSize: "2rem" }}
                      ></AiFillFacebook>
                    </Link>
                  </Col>
                </Row>
                <Row>
                  <Carousel
                    style={{ marginTop: "1rem", marginBottom: "1rem" }}
                    indicators={false}
                    nextIcon={<GrNext style={{ fontSize: "1.5rem" }} />}
                    prevIcon={<GrPrevious style={{ fontSize: "1.5rem" }} />}
                  >
                    {carouselImages}
                  </Carousel>
                </Row>
              </Container>
            </TabPanel>
            <TabPanel value={tabValue} index={1}>
            {isLoaded && (
              <GoogleMap
                id="marker-map"
                mapContainerStyle={{
                  width: "100%",
                  height: "30rem",
                  marginTop: "1rem",
                  marginBottom:'1rem'
                }}
                center={position}
                zoom={14}
                onLoad={onLoad}
                // onLoad={onLoad}
                // onUnmount={onUnmount}
              >
                <Marker key={"Hello World"} position={position}></Marker>
              </GoogleMap>
            )}
            </TabPanel>
            <TabPanel value={tabValue} index={2}>
              <Table striped style={{ marginBottom: "0rem" }}>
                <tbody>{reviewRows}</tbody>
              </Table>
            </TabPanel>
          </SwipeableViews>
        
         
          
        </Card>
      </ErrorBoundary>
    </div>
  );
}
export default Business;
